import React, { useRef } from 'react';
import emailjs from 'emailjs-com';

export default function Form() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_0hd3nes', 'template_u2l6kwe', form.current, 'user_fWGDNMEBe3e1kD3LlRSCV')
      .then((result) => {
        console.log(result.text);
        alert('Thank you! We will contact you as soon');
        form.current.reset()
      }, (error) => {
          console.log(error.text);
      });
  };
  
  return (
    <>
      <form
        ref={form} onSubmit={sendEmail}
        id="request-a-demo"
        className="md:grid grid-cols-2 gap-10 items-center lg:w-2/3"
      >
        <div className="flex flex-col">
          <input
            required
            type="text"
            placeholder="Name / Company"
            className="bg-transparent border-b-2 border-white placeholder-white py-3 lg:text-lg text-white"
          />
          <input
            required
            type="email"
            placeholder="Email address"
            className="bg-transparent border-b-2 border-white placeholder-white py-3 my-10 lg:text-lg text-white"
          />
          <input
            required
            type="phone"
            placeholder="Phone number"
            className="bg-transparent border-b-2 border-white placeholder-white py-3 lg:text-lg text-white"
          />
        </div>
        <div className="mt-10 text-center">
          <button type="submit" href="#request-a-demo" className="btn-white">
            Request a Demo
          </button>
        </div>
      </form>
    </>
  )
}
